import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTACT_PHONE, CONTACT_EMAIL } from "../../lib/api";

export const Footer = () => (
  <footer className="overflow-hidden border-t border-[#1B2A1C]/10 bg-[#F3EEDF]" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 pt-20 sm:px-10">
      <div className="flex flex-col justify-between gap-10 md:flex-row">
        <div className="w-44 overflow-hidden rounded-3xl bg-white p-3 shadow-sm"><img src="/logo.png" alt="Go Box Fruit & Vege" className="w-full" data-testid="footer-logo" /></div>
        <div className="grid content-start gap-2 text-sm text-[var(--sage)]">
          <p>Fresh fruit & vege boxes, Nelson NZ</p>
          <a href={`tel:${CONTACT_PHONE.replace(/\s/g, "")}`} className="link-underline self-start text-white" data-testid="footer-phone">{CONTACT_PHONE}</a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="link-underline self-start break-all text-white" data-testid="footer-email">{CONTACT_EMAIL}</a>
        </div>
        <Link to="/admin" className="link-underline self-start text-sm text-[var(--sage)] hover:text-white" data-testid="nav-admin-link">Admin</Link>
      </div>
      <motion.p
        initial={{ y: "40%", opacity: 0 }}
        whileInView={{ y: "0%", opacity: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="mt-16 select-none font-display text-[27vw] font-extrabold leading-[0.78] tracking-[-0.06em] text-[#E6DCC2] lg:text-[22rem]"
        aria-hidden="true"
      >
        Go Box
      </motion.p>
    </div>
  </footer>
);
